<template>
  <div class="container sign-up">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-xl-6 col-lg-6 pt-5">
        <FadeTransition>
          <div v-if="initialized">
            <div v-if="!cognitoLogin">
              <h1 class="display-4 text-center mb-3">Confirm your mobile number</h1>
              <p class="text-muted text-center mb-5">
                {{ invite.inviter.firstName }} has invited you to join the
                <strong>{{ companyNamesText() }}</strong> {{ isMultiple ? 'teams.' : 'team.' }}
              </p>
              <InvitedForm :invite="invite" @joined="joined" />
            </div>
            <div v-else>
              <!-- Replace Amplify components with your own signup form -->
              <div class="signup-form">
                <h2 class="text-center mb-4">
                  {{ invite.inviter.firstName }} has invited you to join the
                  {{ companyNamesText() }} {{ isMultiple ? 'teams.' : 'team.' }}
                </h2>
                <!-- Add your custom signup form here -->
                <form @submit.prevent="handleCustomSignUp">
                  <div class="form-group">
                    <label for="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      class="form-control"
                      v-model="formData.email"
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      class="form-control"
                      v-model="formData.password"
                      required
                    />
                  </div>
                  <button type="submit" class="btn btn-primary btn-block">Create Account</button>
                </form>
              </div>
            </div>
          </div>
          <div v-if="errMessage" class="alert alert-danger" role="alert">
            {{ errMessage }}
          </div>
        </FadeTransition>
      </div>
    </div>
  </div>
</template>

<script>
import InvitedForm from '@/components/Modules/User/InvitedForm'
import FadeTransition from '@/components/Transitions/FadeTransition'
import CompanyService from '@/services/CompanyService'
import { trackEvent } from '@/lib/analytics'

export default {
  name: 'InvitePage',
  components: {
    InvitedForm,
    FadeTransition
  },
  data: () => ({
    initialized: false,
    cognitoLogin: false,
    errMessage: undefined,
    invite: {},
    formData: {
      email: '',
      password: ''
    },
    companies: [],
    isMultiple: false,
    termsAccepted: false
  }),
  methods: {
    joined() {
      this.$router.push({ name: 'dashboard' })
    },
    async handleCustomSignUp() {
      // Replace with your own signup logic
      try {
        // Your custom signup implementation here
        console.log('Custom signup:', this.formData)

        // Track event
        trackEvent(this.$intercom, 'Terms of Use Accepted', {
          timestamp: this.$moment().toISOString(),
          value: this.termsAccepted,
          user: this.invite.employee
        })

        // Redirect to dashboard or handle success
        this.joined()
      } catch (error) {
        console.error('Signup failed:', error)
        this.errMessage = 'Signup failed. Please try again.'
      }
    },
    companyNamesText() {
      let nameText = ''
      if (this.companies.length === 1) {
        const company = this.companies[0]
        nameText = company.name
      } else if (this.companies.length === 2) {
        const company = this.companies[0]
        const company1 = this.companies[1]
        nameText = `${company.name} and ${company1.name}`
      } else {
        const company = this.companies[0]
        const company1 = this.companies[1]
        const teamCount = this.companies.length - 2
        nameText = `${company.name}, ${company1.name}, and ${teamCount} other`
        if (teamCount > 1) this.isMultiple = true
      }
      return nameText
    }
  },
  async mounted() {
    trackEvent(this.$intercom, 'Accepting signup invitation')
    try {
      const response = await CompanyService.getInvite(this.$route.params.token)
      const { invite } = response.body
      this.invite = invite
      if (this.invite.cognitoAuthentication === true) {
        this.formData.email = invite.employee.email
        this.cognitoLogin = true
      }
      if (invite.company) {
        this.companies = [invite.company]
      } else {
        this.companies = [...invite.companies]
      }
      this.initialized = true
    } catch (err) {
      this.errMessage = err.body.message
    }
  }
}
</script>

<style scoped lang="scss"></style>
